import moment from '~~/utils/moment';

export default defineNuxtPlugin(() => {
    return {
        provide: {
            moment: (date: string) => moment(date),
        },
    };
});
